import { useParams } from 'react-router';
import { useArticleBody } from '@/lib/useArticleBody';
import ArticleDetail from '@components/pages/ArticleDetail';
import { ARTICLES, getArticle } from '@/data/resources';
import { inlinedRecord } from '@/lib/inlinedRecord';
import { articleFrom } from '@/lib/siteContent';

export default function BlogArticle() {
    const { slug } = useParams();
    // The pool wins once the feed lands; until then the copy the server wrote
    // into the page means this renders without waiting for a request of its own.
    const inlined = inlinedRecord('articles', slug);
    const { item: article, bodyPending } = useArticleBody(
        getArticle(slug) ?? (inlined ? articleFrom(inlined) : undefined),
        'articles',
    );

    return (
        <ArticleDetail
            item={article}
            bodyPending={bodyPending}
            related={ARTICLES.filter((a) => a.slug !== slug).slice(0, 4)}
            basePath="/resources/blog"
            backLabel="Back to Blog"
            relatedLabel="Related Articles"
        />
    );
}
